export default __webpack_public_path__ + "static/media/prev.8112fa03.svg";